"use client";

import { useEffect } from 'react';
import '@/lib/i18n';

interface I18nProviderProps {
  children: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  useEffect(() => {
    // Initialize i18n on client side
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage) {
      // Language will be set by i18next initialization
    }
  }, []);

  return <>{children}</>;
}